import { Box, Icon, Tooltip, Typography } from '@branch-messenger/willow-ui'
import { AlertCircleFilled } from '@branch-messenger/willow-ui/icons'
import { FC } from 'react'

type AdvanceAmountHeaderProps = {
  minAdvanceAmount: string
}

export const AdvanceAmountHeader: FC<AdvanceAmountHeaderProps> = ({
  minAdvanceAmount,
}) => {
  return (
    <Box $display="flex" $justify="space-between">
      <Typography $bold>{`Advance amount`}</Typography>
      {minAdvanceAmount && (
        <Typography
          as={'div'}
          $italicized
          $size="xs"
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '4px',
          }}
        >
          {`${minAdvanceAmount} minimum`}
          <Tooltip
            trigger={
              <Box $display="inline-flex" $align="center" $justify="center">
                <Icon Icon={AlertCircleFilled} color="selection" />
              </Box>
            }
          >
            {`To keep fees fair and affordable, the minimum advance amount is ${minAdvanceAmount}. This ensures you're not paying a high fee for a small advance.`}
          </Tooltip>
        </Typography>
      )}
    </Box>
  )
}
